/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Snigdha <snigdha.dhanireddy@mroads.com>, February 2021
 * @format
 * @flow
 */

import { ActionTypes } from '../constants';

export function addException(log: { message: String, stackTrace: String }) {
  return {
    type: ActionTypes.SERVERAPP_ADD_EXCEPTION,
    payload: { log },
  };
}
